import { NgModule } from '@angular/core';
import { BrowserModule } from '@angular/platform-browser';
import { provideHttpClient } from '@angular/common/http';
import { AppRoutingModule } from './app-routing.module';
import { AppComponent } from './app.component';
import { BrowserAnimationsModule } from '@angular/platform-browser/animations';
import { MatSidenavModule } from '@angular/material/sidenav';
import { ReactiveFormsModule } from '@angular/forms';
import { RegistrationComponent } from './registration/registration.component';
import { MatToolbarModule } from '@angular/material/toolbar';
import { MatButtonModule } from '@angular/material/button';
import { MkplOnboardingComponent } from './mkpl-onboarding/mkpl-onboarding.component';
import { TenantInfoComponent } from './tenant-info/tenant-info.component';
import { SolutionInfoComponent } from './solution-info/solution-info.component';
import { MatFormFieldModule } from '@angular/material/form-field';
import { MatInputModule } from '@angular/material/input';
import { MatSelectModule } from '@angular/material/select';
import { MatSnackBarModule } from '@angular/material/snack-bar';
import { MatProgressSpinnerModule } from '@angular/material/progress-spinner';
import { MatSlideToggleModule } from '@angular/material/slide-toggle';
import { MatTooltipModule } from '@angular/material/tooltip';
import { MatIconModule } from '@angular/material/icon';
import { SignupDoneComponent } from './signup-done/signup-done.component';
import { AtlasSignupComponent } from './atlas-signup/atlas-signup.component';
import { AtlasSubscribeComponent } from './atlas-subscribe/atlas-subscribe.component';
import { AtlasCheckoutSuccessComponent } from './atlas-checkout-success/atlas-checkout-success.component';
import { AtlasCheckoutCancelComponent } from './atlas-checkout-cancel/atlas-checkout-cancel.component';
import { ActivateAccountComponent } from './activate-account/activate-account.component';


@NgModule({
  declarations: [
    AppComponent,
    RegistrationComponent,
    MkplOnboardingComponent,
    TenantInfoComponent,
    SolutionInfoComponent,
    SignupDoneComponent,
    AtlasSignupComponent,
    AtlasSubscribeComponent,
    AtlasCheckoutSuccessComponent,
    AtlasCheckoutCancelComponent,
    ActivateAccountComponent,
  ],
  imports: [
    BrowserModule,
    AppRoutingModule,
    BrowserAnimationsModule,
    MatToolbarModule,
    MatButtonModule,
    MatSidenavModule,
    ReactiveFormsModule,
    MatFormFieldModule,
    MatInputModule,
    MatSelectModule,
    MatSnackBarModule,
    MatProgressSpinnerModule,
    MatSlideToggleModule,
    MatTooltipModule,
    MatIconModule,
  ],
  providers: [provideHttpClient()],
  bootstrap: [AppComponent],
})
export class AppModule {}
